export type ModelInfo = {
  id: string;
  name: string;
  provider: string;
};

// Pick the model a fresh chat should start on: the admin-curated default when
// it is present in the enabled catalog, otherwise the first model (the API
// already sorts the admin default first, so models[0] is a safe fallback for
// older API deployments that don't return defaultModelId yet). Returns null
// only when there are no models at all.
export const resolveDefaultModelId = (
  models: ModelInfo[],
  defaultModelId: unknown,
): string | null => {
  if (models.length === 0) {
    return null;
  }
  if (
    typeof defaultModelId === 'string' &&
    models.some(model => model.id === defaultModelId)
  ) {
    return defaultModelId;
  }
  return models[0].id;
};
